import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ValidateField } from 'src/util/validators';
import { errorSnackBar, warningSnackBar } from '../../actions/common.action';
import {
    deleteGlobalSetting,
    editGlobalSetting,
    editProjectTypeSetting,
    getProjectCategory, UpdateProjectType
} from '../../actions/global-setting.action';
import { verifyPassword } from '../../actions/user-management.action';
import CustomInput from '../../components/inputs/new-input';
import SelectInput from '../../components/inputs/select';
import Modal from '../../components/modal/modal';
import CustomTable from '../../components/table/table';
import {
    projectCategoryDeleteFields,
    projectCategoryFields
} from '../../constants/fields.constant';
import './scss/templates.scss';

class ProjectSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            fields: {
                ...JSON.parse(JSON.stringify(projectCategoryFields))
            },
            deleteFields: {
                ...JSON.parse(JSON.stringify(projectCategoryDeleteFields))
            },
            columns: [],
            typeId: null,
            anchorEl: null,
            selectedProjectType: null,
            projectCategories: [],
            viewType: '',
            deleteDialogopen: false,
        }
    }

    componentDidMount() {
        this.getProjectTypes()
    }

    inputChangeHandler(e) {
        let fields = this.state.fields
        let deleteFields = this.state.deleteFields
        var name
        var value
        if (_.isObject(e)) {
            name = e.target.name
            value = e.target.value
        }

        if (name === 'name' || name === 'type') {
            fields[name].value = value
            fields[name].touched = true
            const { error, valid } = ValidateField({ value, validation: fields[name].validation });
            fields[name].error = error
            fields[name].valid = valid
        }

        if (name === 'password' || name === 'selectedType') {
            deleteFields[name].value = value
            deleteFields[name].touched = true
            const { error, valid } = ValidateField({ value, validation: deleteFields[name].validation });
            deleteFields[name].error = error
            deleteFields[name].valid = valid
        }

        this.setState({ fields, deleteFields })
    }

    openDialog(id = '') {
        let viewType = 'Add'
        if (id) {
            viewType = 'Edit'
            this.setValuetoEditModal(id)
        }
        this.setState({ open: true, viewType: viewType, selectedProjectType: id })
    }
    handleAddDialog() {
        let viewType = 'Add'
        this.setState({ open: true, viewType: viewType })
    }

    dialogClose = () => {
        let { open } = this.state
        this.setState({ open: !open, selectedProjectType: null, fields: { ...JSON.parse(JSON.stringify(projectCategoryFields)) } })
        this.handleCloseAnchorEl()
    }

    submitForm = async () => {
        let { fields, projectCategories, viewType, selectedProjectType } = this.state
        let isFormValid = true
        for (let key in fields) {
            const { error, valid } = ValidateField({ value: fields[key].value, validation: fields[key].validation });
            fields[key].touched = true;
            fields[key].valid = valid;
            fields[key].error = error;
            isFormValid = isFormValid && valid;
        }

        if (!isFormValid) {
            this.setState({ fields })
        } else {
            // Map all categories, including deleted ones
            let projectTypes = projectCategories.map((item) => {
                let { name, type, is_delete, deleted_at, deleted_by } = item;
                let obj = {
                    name: viewType === 'Edit' && type === selectedProjectType ? fields.name.value : name,
                    type: viewType === 'Edit' && type === selectedProjectType ? fields.type.value : type,
                    is_delete: is_delete || false,
                    deleted_at: deleted_at || null,
                    deleted_by: deleted_by || null
                };
                return obj;
            });
            if (viewType === 'Add') {
                let typeExits = projectCategories.find(item => item.is_delete === false && item.type === fields.type.value)
                if (typeExits) {
                    this.props.warningSnackBar('The Project Type code already exits, please use a different code')
                    return false;
                }
                let data = {
                    name: fields.name.value,
                    type: fields.type.value,
                    is_delete: false,
                    deleted_at: null,
                    deleted_by: null
                };
                projectTypes.push(data);
            }
            await this.props.editProjectTypeSetting(projectTypes, 'PROJECTCATEGORIES')
            this.getProjectTypes()
            this.dialogClose()
        }
    }

    handleMenu = (event, row) => {
        this.setState({ anchorEl: event.currentTarget, selectedProjectType: row.type });
    };

    handleCloseAnchorEl = () => {
        this.setState({ anchorEl: null, selectedProjectType: null })
    }

    getProjectTypes = async () => {
        await this.props.getProjectCategory('PROJECTCATEGORIES');
        // Store all categories in state
        let allCategories = (Array.isArray(this.props.projectCategories) && this.props.projectCategories.map((item, index) => {
            return { ...item, id: index };
        })) || [];

        let columns = [
            { title: 'Name', field: 'name' },
            { title: 'Code', field: 'type' }
        ]

        this.setState({ columns, projectCategories: allCategories })
    }

    setValuetoEditModal(id) {
        let { fields, projectCategories } = this.state;
        let type = projectCategories.find(item => item.type === id)
        fields['name'].value = type.name;
        fields['type'].value = type.type;
        this.setState({ fields })
    }

    deleteDialogHandler(id = '') {
        let { deleteFields, projectCategories } = this.state
        deleteFields.selectedType.items = projectCategories
            .filter((item) => !item.is_delete && item.type !== id)
            .map(v => ({
                key: v.name,
                value: v.type
            })) || [];
        this.setState({ deleteDialogopen: true, deleteFields, selectedProjectType: id })
    }

    deleteDialogClose = () => {
        let { deleteDialogopen, deleteFields } = this.state
        deleteFields.selectedType.valid = true;
        deleteFields.selectedType.value = '';
        deleteFields.password.valid = true;
        deleteFields.password.value = '';
        this.setState({ deleteDialogopen: !deleteDialogopen, selectedProjectType: null, deleteFields })
        this.handleCloseAnchorEl()
    }


    deleteProjectType = async () => {
        let { projectCategories, selectedProjectType, deleteFields } = this.state

        let isFormValid = true
        for (let key in deleteFields) {
            const { error, valid } = ValidateField({ value: deleteFields[key].value, validation: deleteFields[key].validation });
            deleteFields[key].touched = true;
            deleteFields[key].valid = valid;
            deleteFields[key].error = error;
            isFormValid = isFormValid && valid;
        }

        if (!isFormValid) {
            this.setState({ deleteFields })
        } else {
            try {
                // First verify the password
                await this.props.verifyPassword(deleteFields.password.value);

                // If password is valid, proceed with deletion
                let projectTypes = projectCategories.map((item) => {
                    let { name, type: itemType } = item;
                    return {
                        name,
                        type: itemType,
                        is_delete: itemType === selectedProjectType ? true : item.is_delete
                    };
                });

                // Add the new type mapping for projects
                await this.props.UpdateProjectType({ projectType: deleteFields.selectedType.value }, selectedProjectType)
                await this.props.editProjectTypeSetting(projectTypes, 'PROJECTCATEGORIES')
                this.getProjectTypes()

                // Reset password field to initial state
                this.setState({
                    deleteFields: {
                        ...JSON.parse(JSON.stringify(projectCategoryDeleteFields))
                    }
                })
                this.deleteDialogClose()
            } catch (error) {
                this.setState({
                    deleteFields: {
                        ...deleteFields,
                        password: {
                            ...deleteFields.password,
                            error: error.message
                        }
                    }
                })
            }
        }
    }


    render() {
        const { open, fields, columns, projectCategories, viewType, deleteDialogopen, deleteFields } = this.state

        // Filter deleted items only for display
        const displayCategories = projectCategories.filter(item => !item.is_delete);

        return (
            <>
                <Modal
                    open={open}
                    onClose={this.dialogClose}
                    onClick={this.submitForm}
                    modalHeading={`${viewType} Project type`}
                    modalSaveTxt={'Save'}
                    modalCloseTxt='Close'
                    showActionBtn={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    cxlbtnClass='cancelBtn'
                    primary
                >
                    <div className='row mb-4'>
                        <div className="col-lg-6 mt-3">
                            <CustomInput
                                {...fields.name}
                                label={'Name'}
                                onChange={(e) => this.inputChangeHandler(e)}
                            />
                        </div>
                        <div className="col-lg-6 mt-3">
                            <CustomInput
                                {...fields.type}
                                label={'Code'}
                                disabled={viewType === 'Edit' ? true : false}
                                onChange={(e) => this.inputChangeHandler(e)}
                            />
                        </div>
                    </div>
                </Modal>
                <Modal
                    open={deleteDialogopen}
                    onClose={this.deleteDialogClose}
                    onClick={this.deleteProjectType}
                    modalHeading={`Delete Project type`}
                    modalSaveTxt={'Save'}
                    modalCloseTxt='Cancel'
                    showActionBtn={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    cxlbtnClass='cancelBtn'
                    primary
                >
                    <p>Are You Sure You Want to Delete this Project Type?</p>
                    <p>To do so please select the project type you would like to move Projects within this Type to. Then select Save. Otherwise select Cancel to exit.</p>
                    <div className="col-12 mt-3 mb-4">
                        <div className='mt-3 mb-4'>
                            <SelectInput
                                label={'Project Type'}
                                {...deleteFields.selectedType}
                                onChange={(e) => this.inputChangeHandler(e)}
                            />
                        </div>
                        <div className="mt-4">
                            <CustomInput
                                {...deleteFields.password}
                                onChange={(e) => this.inputChangeHandler(e)}
                            />
                        </div>
                    </div>
                </Modal>
                <div className="purchase-order-block">
                    <div className="row">
                        <CustomTable
                            columns={columns}
                            data={displayCategories}
                            addButton={this.props.writePermission}
                            addHandler={() => this.handleAddDialog()}
                            isEdit={this.props.writePermission}
                            editHandler={(item) => this.openDialog(item.type)}
                            isDelete={this.props.writePermission}
                            deleteHandler={(item) => this.deleteDialogHandler(item.type)}
                            fileName='Project Categories List'
                        />
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    projectCategories: state.project.projectCategories
});

const mapDispatchToProps = dispatch => ({
    getProjectCategory: bindActionCreators(getProjectCategory, dispatch),
    errorSnackBar: bindActionCreators(errorSnackBar, dispatch),
    editGlobalSetting: bindActionCreators(editGlobalSetting, dispatch),
    deleteGlobalSetting: bindActionCreators(deleteGlobalSetting, dispatch),
    editProjectTypeSetting: bindActionCreators(editProjectTypeSetting, dispatch),
    UpdateProjectType: bindActionCreators(UpdateProjectType, dispatch),
    warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
    verifyPassword: bindActionCreators(verifyPassword, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ProjectSetting);
